import styled from 'styled-components'

import colors from './colors'

const SwipeRowWrapper = styled.div`
  border-radius: .6rem;
  margin: 0 -1rem;
  position: relative;

  @media (max-width: 500px) {
    margin: 0 -.5rem;
    border-radius: 0;
  }
`
const SwipeRowActionsWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
`
const SwipeRowAction = styled.div`
  color: white;
  padding: 0 1rem;
  text-align: ${p => p.right ? 'right' : 'left'};
`
const PersonListItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-column-gap: 1rem;
  padding: .5rem 1rem;
  text-decoration: none;
  cursor: pointer;
  border-radius: .5rem;
  background: white;
  user-select: none;
  z-index: 10;
  position: relative;
  
  &:hover {
    background: ${'#fafafa'};
  }
  @media (max-width: 500px) {
    border-radius: 0;
    padding: .5rem .5rem;
  }
`
const PersonListItemInfoTitle = styled.div`
  font-size: 1.2rem;
  color: ${colors.primaryText};
  display: inline-block;
  margin: 0 .66rem 0 0;
  line-height: 1.2;
`
const PersonListItemInfoSub = styled.div`
  color: ${colors.tertiaryText};
  display: inline-block;
  font-size: .9rem;
  margin: 0 .5rem 0 0;
  line-height: 1.2;

  @media (max-width: 500px) {
    display: block;
  }
`
const PersonBubble = styled.div`
  background: white;
  box-shadow: 0 2px 10px hsla(0, 0%, 0%, .3);
  padding: 1rem;
  border-radius: .5rem;
  z-index: 205;
  position: relative;
  margin: 0 -1rem;
`
const PersonBubbleBackground = styled.div`
  background: hsla(0, 0%, 100%, .5);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 200;
  transition: all .2s ease;
`

export {
  SwipeRowWrapper,
  SwipeRowActionsWrapper,
  SwipeRowAction,
  PersonListItemWrapper,
  PersonListItemInfoTitle,
  PersonListItemInfoSub,
  PersonBubble,
  PersonBubbleBackground,
}



// WEBPACK FOOTER //
// ./src/styles/lists.js